<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="03-Dachform" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="D_03.3_Dachform---25-Grad" transform="translate(-477.000000, -1007.000000)">
        <g id="Process" transform="translate(381.000000, 984.000000)">
          <g id="Organization-/-Status-/-checkmark--filled-/-24" transform="translate(96.000000, 23.000000)">
            <path
              d="M7,0.583333333 C3.5,0.583333333 0.583333333,3.5 0.583333333,7 C0.583333333,10.5 3.5,13.4166667 7,13.4166667 C10.5,13.4166667 13.4166667,10.5583333 13.4166667,7 C13.4166667,3.44166667 10.5583333,0.583333333 7,0.583333333 Z M6.06666667,9.50833333 L3.79166667,7.23333333 L4.55,6.53333333 L6.125,8.10833333 L9.50833333,4.725 L10.2666667,5.48333333 L6.06666667,9.50833333 L6.06666667,9.50833333 Z"
              id="Fill"
              fill="currentColor"
            ></path>
            <polygon
              id="Inner-Fill"
              fill="#000000"
              opacity="0"
              points="6.06666667 9.50833333 3.79166667 7.23333333 4.55 6.53333333 6.125 8.10833333 9.50833333 4.725 10.2666667 5.48333333 6.06666667 9.50833333"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckCircleFilled'
};
</script>
